import { banksFormat } from '../../utils/bankList'
export const banks = (dataConexiones) => {

  const banks = dataConexiones?.filter(
    (f) => !!banksFormat[f?.templateId]
  );
  return banks;
};

export const integrated = (dataConexiones) => {
  const integratedList = {
    sii: "sii",
    siiApoderado: "siiApoderado",
    clayApiToken: "clayApiToken",
    talana: "talana",
    transbank: "transbank",
    bsaleApiToken: "bsaleApiToken",
    piriodApiToken: "piriodApiToken",
    previred: "previred",
    buk: "buk",
    buk_editor: "buk_editor",
    cobranzaOnline: "cobranzaOnline",
    rindegastos: "rindegastos",
    fincloud: "fincloud",
  };
  const integrated = dataConexiones?.filter(
    (f) => f?.templateId === integratedList[f?.templateId]
  );
  return integrated;
};

export const otherConections = (dataConexiones) => {
  const otherConectionList = {
    usernamePassword: "usernamePassword",
    companyUser: "companyUser",
    facturacion: "facturacion",
    emailPassword: "emailPassword",
    rutRutPassword: "rutRutPassword",
    nubox: "nubox",
    libreDteApiToken: "libreDteApiToken",
  };
  const otherConections = dataConexiones?.filter(
    (f) => f?.templateId === otherConectionList[f?.templateId]
  );
  return otherConections;
};
